import { render, staticRenderFns } from "./tableOccurrenceModal.vue?vue&type=template&id=50f09919&scoped=true&"
import script from "./tableOccurrenceModal.vue?vue&type=script&lang=js&"
export * from "./tableOccurrenceModal.vue?vue&type=script&lang=js&"
import style0 from "./tableOccurrenceModal.vue?vue&type=style&index=0&id=50f09919&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f09919",
  null
  
)

export default component.exports